import { useState } from "react";

// Macrosezione della scheda pratica: barra navy col titolo, azioni a destra, corpo richiudibile.
export default function Sezione({ titolo, azioni, children, aperta = true, testid, badge, piatto }) {
  const [open, setOpen] = useState(aperta);
  return (
    <section data-testid={testid} className="sez">
      <div className="barra">
        <button data-testid={`${testid}-toggle`} onClick={() => setOpen(!open)}
          className="flex items-center gap-2.5 min-w-0 text-left">
          <h2>{titolo}</h2>
          <span className="text-white/60 text-[13px] font-semibold">{open ? "−" : "+"}</span>
          {badge}
        </button>
        {azioni && <span className="flex flex-wrap items-center gap-2.5">{azioni}</span>}
      </div>
      {open && <div className="corpo" style={piatto ? { padding: 0, gap: 0 } : undefined}>{children}</div>}
    </section>
  );
}
